import React from "react";

export type UseDialogStateProps = {
    onOpen?: () => void;
    onClose?: () => void;
};

const useDialogState = (props?: UseDialogStateProps) => {
    const [open, setOpen] = React.useState(false);

    const onClose = React.useCallback(() => {
        setOpen(false);
        props?.onClose?.();
    }, []);
    const onOpen = React.useCallback(() => {
        setOpen(true);
        props?.onOpen?.();
    }, []);
    const onOpenClose = React.useCallback(
        (shouldOpen: boolean) => {
            if (shouldOpen) {
                onOpen();
            } else {
                onClose();
            }
        },
        [onClose, onOpen]
    );

    return {
        open,
        onOpen,
        onClose,
        onOpenClose,
    };
};

export default useDialogState;
